import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'create-site',
  templateUrl: './create-site.component.html'
})
export class CreateSiteComponent {
  disableBrand: boolean = false;

  constructor(public dialogRef: MatDialogRef<CreateSiteComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (this.data.selectedBrand) {
      this.disableBrand = true;
    }
  }

  save() {
    this.dialogRef.close(this.data);
  }
}
